const browserInfo = {
  JavaEnabled: false,
  Language: navigator.language,
  ColorDepth: window.screen.colorDepth,
  ScreenHeight: window.screen.height,
  ScreenWidth: window.screen.width,
  TimeZoneOffset: new Date().getTimezoneOffset().toString(),
  UserAgent: navigator.userAgent,
};

export { browserInfo };
